import LazyLoad from 'vanilla-lazyload';
import animations from '../components/animations';
import accordion from '../components/accordion';
import loadmore from '../components/load-more';
import reviews from '../components/reviews';
import sliders from '../components/sliders';
import sequencedvideo from '../components/sequenced-video';
import ScrollToAnchor from '../components/scroll-to-anchor';
import skipTo from '../components/skip-to';
import nav from '../components/nav';
import attributeRadios from '../components/attribute-radios';
import customExtraAddCartFields from '../components/custom-extra-add-cart-fields';
import customSelects from '../components/custom-selects';
import toggleVariations from '../components/toggle-variations';
import customNumberInputs from '../components/custom-number-input';
import attributeSteps from '../components/attribute-steps';
import faqAccordion from '../components/faq-accordion';
import tabFunction from '../components/tabFunction';
import gsapSticky from '../components/gsapSticky';
import keyFeaturesSpotlight from '../components/key-features-spotlight';
import configurator from '../components/configurator';

import '../vendor/jquery.match-height';

import 'magnific-popup';

export default {
  init() {
    
    // JavaScript to be fired on all pages
    var lazyLoading = function () {
      var lazyLoaders = [new LazyLoad({
        elements_selector: '.lazy',
        threshold: 600,
      })];

      jQuery(document).on('lazyrefresh', function () {
        lazyLoaders.forEach(function (lazyLoader) {
          lazyLoader.update();
        });
      });
    }

    $('.js-scroll-to').each(function () {
      new ScrollToAnchor(this);
    });

    lazyLoading();
    animations.init();
    accordion.init();
    loadmore.init();
    sequencedvideo.init();
    skipTo();
    nav.init();
    attributeRadios.init();
    customSelects.init();
    customNumberInputs();
    attributeSteps();
    faqAccordion.init();
    tabFunction.init();
    gsapSticky.init();
    keyFeaturesSpotlight.init();

    setTimeout(function () {
      $('.btnwatch').each(function () {
        var url = this.getAttribute('href')
        if (url) {
          try {
            var href = new URL(url)
            var params = new URLSearchParams(href.search)
            params.delete('_ga')
            var new_url = href.origin + href.pathname + '?' + params.toString()
            this.setAttribute('href', new_url)
          } catch (e) {
            console.warn('This video URL ("' + url + '") does not follow the correct structure. Is it missing the "https://" protocol?')
          }
        }
      })
    }, 1000)


    $('.js-match').matchHeight();

    if ($('#dropdown-640').length) {
      reviews.init();
    }

    $('.js-popup-modal').magnificPopup({
      type: 'inline',
      mainClass: 'mfp-fade',
    });

    $('.js-inlinepopup').magnificPopup({
      type: 'iframe',
      removalDelay: 300,
      mainClass: 'mfp-fade',
    });

    $('.js-galleryzoom').magnificPopup({
      removalDelay: 300,
      mainClass: 'mfp-fade',
      type: 'image',
      gallery: {
        enabled: true,
      },
    });

    $('.js-product-gallery').magnificPopup({
      removalDelay: 300,
      mainClass: 'mfp-fade',
      type: 'image',
      delegate: '.slick-slide:not(.slick-cloned) a',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
      },
    });

    var observer = new MutationObserver(function () {
      // fired when a mutation occurs
      $('.woocommerce-product-gallery__image').magnificPopup({
        removalDelay: 300,
        mainClass: 'mfp-fade',
        type: 'image',
        delegate: 'a',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
        },
      });
      // ...
    });

    // define what element should be observed by the observer
    // and what types of mutations trigger the callback
    observer.observe(document, {
      subtree: true,
      attributes: true,
      //...
    });
  },

  finalize() {
    customExtraAddCartFields.init();
    toggleVariations.init();
    sliders.init();
    configurator.init();


    // Function to observe when the custom table is added to the DOM
    const observeCustomTable = () => {
      const observer = new MutationObserver((mutationsList, observer) => {
        mutationsList.forEach(mutation => {
          if (mutation.type === 'childList') {
            // Check if the custom table has been added to the DOM
            const customTable = document.querySelector('.custom-table');
            if (customTable) {
              // Now initialize the magnificPopup
              $('.js-popup-modal').magnificPopup({
                type: 'inline',
                mainClass: 'mfp-fade',
              });

              // Once the table is detected and popup is initialized, stop observing
              observer.disconnect();
            }
          }
        });
      });

      // Start observing the document body or a more specific parent node
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    };

    // Call the observer to monitor for the custom table
    observeCustomTable();
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js